import type { TabId } from '@/components/account/search/ResultsPanel';
import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export type SearchResultsQueryParams = {
  searchTerm: string;
  activeTab: TabId;
};

export const Route = createFileRoute('/searchResults')({
  component: lazyRouteComponent(() => import('../components/account/search/SearchResultsPage')),
  validateSearch: validateQueryParams,
});

export function validateQueryParams(search: Record<string, string>): SearchResultsQueryParams {
  // validate and parse the search params into a typed state
  return {
    searchTerm: String(search.searchTerm) || '',
    activeTab: assertTabId(search.activeTab) ? search.activeTab : 'roots',
  };
}

function assertTabId(tabId: string): tabId is TabId {
  return tabId === 'roots' || tabId === 'persons';
}
